export default __webpack_public_path__ + "static/media/forest.47a6a3d1.ogg";